export default {
    companyName: '上海鼎充新能源技术有限公司版权所有',
    companyICP: '苏ICP备15008760号-3',
    companyName_1: '亨通慧充众联科技有限公司',
    companyICP_1: '沪ICP备15017026号-3',
    address: '江苏省苏州市吴江区交通北路168号',
    telPhone: '电话：400-118-5655',
    record: '备案号'
}